import { Box } from "@mui/material"
import React from "react"

import { s } from "../../../utilities/common"

export const GradientOverlay = ({ type }: { type: "full" | "small" }) =>
  type === "full" ? (
    <>
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100vh",
          top: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100vh",
          top: 0,
          background:
            "linear-gradient(180deg, rgba(21, 31, 49, 0.15) 0%, rgba(21, 31, 49, 0.15) 50.79%, #151F31 92.88%, #151F31 100%), linear-gradient(180deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0) 49.87%)",
        }}
      />
    </>
  ) : (
    <>
      <Box
        sx={{
          position: "absolute",
          width: s("1242px"),
          height: s("699px"),
          top: 0,
          backgroundColor: "rgba(0, 0, 0, 0.15)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: s("1242px"),
          height: s("699px"),
          top: 0,
          background:
            "linear-gradient(90deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0) 49.87%), linear-gradient(90deg, rgba(21, 31, 49, 0) 0%, rgba(21, 31, 49, 0) 50.79%, #151F31 92.88%, #151F31 100%)",
        }}
      />
    </>
  )
